export enum MetadataInputType {
    Text = "Text",
    Autocomplete = "Autocomplete",
}